import React from 'react';
import PropTypes from 'prop-types';

function Search({ className }) {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" className={className}>
      <g fill="none" fillRule="evenodd">
        <path d="M.467 8.1a7.633 7.633 0 1 1 15.267 0 7.633 7.633 0 0 1-15.267 0zm2 0a5.633 5.633 0 1 0 11.267 0 5.633 5.633 0 0 0-11.267 0z" fill="currentColor" fillRule="nonzero" />
        <path d="M12.83 12.74l5.108 5.11" stroke="currentColor" strokeWidth="2" />
      </g>
    </svg>
  );
}

Search.propTypes = {
  className: PropTypes.string,
};

Search.defaultProps = {
  className: '',
};

export default Search;
